<div
  class="phone-field"
  [class.phone-field--focused]="focused"
  [class.phone-field--disabled]="isDisabled"
>
  <input #phoneInput type="tel" [attr.required]="required || null" />
</div>
